import Cart from "../features/cart/Cart";
import NavBar from "../features/navbar/Navbar";
import MainLayout from "../components/MainLayout";

function CartPage() {
    return (
        <MainLayout>
            <NavBar>
                <Cart></Cart>
            </NavBar>
        </MainLayout>
    );
}

export default CartPage;